export class AtaCarnetNocLetterModel {
    body: Body = new Body();
}

export class Body {
    ProcessName: string = 'DC Community Portal SR Process Wrapper WF';
    DCMethod: string = 'SUBMIT';
    DCLoginName: string = '';
    DCLanguage: string = 'ENU';
    DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}

export class DCIncomingHierarchy {
    MessageId: string = '';
    IntObjectName: string = 'DC Community Portal SR Upsert IO';
    MessageType: string = 'Integration Object';
    IntObjectFormat: string = 'Siebel Hierarchical';
    "ListOfDC Community Portal SR Upsert IO": ListOfDCCommunityPortalSRUpsertIO =
        new ListOfDCCommunityPortalSRUpsertIO();
}

export class ListOfDCCommunityPortalSRUpsertIO {
    "DC Community Portal SR": DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCCommunityPortalSR {
    "SR Number": string = '';
    CSN: string = '';
    "SR Type": string = '';
    "Sub Type": string = '';
    "DC Payment Method": string = '';
    "DC Channel": string = 'Online';
    "DC Processing Type": string = '';
    "DC Holder Mobile": string = '';
    "DC Holder Phone": string = '';
    "DC Holder Email": string = '';
    "DC Carnet Type": string = '';
    "DC ATA NOC Letter Type": string = '';
    "DC Carnet Number": string = '';
    "DC Foreign Carnet Number": string = '';
    "DC ATA Consent": string = "Y";
    "DC ATA Pledged Letter Consent": string = "Y";
    "DC Bank Detail Consent": string = "Y";
    "ListOfDC Community Portal SR Notes" = {
        "DC Community Portal SR Notes": null as DCCommunityPortalSRNotes[] | null
    };
}

export class DCCommunityPortalSRNotes {
    "Note": string = "";
    "Note Type": string = "";
}

